import { SET_ERROR_MODAL_SUCCESS } from './ErrorParticipantModal.actions'

const initialState = {
  error: false,
  loading: false,
  showErrorParticipantModal: false,
  errorMessages: [],
  errorTitle: ''
}

/**
 * The reducer for the error Participants modal
 */
const errorParticipantModalReducer = (state = initialState, { payload, type }) => {
  switch (type) {
    case SET_ERROR_MODAL_SUCCESS: {
      return {
        ...state,
        showErrorParticipantModal: payload.showErrorParticipantModal,
        errorMessages: payload.errorMessages,
        errorTitle: payload.errorTitle,
        loading: false,
        error: false
      }
    }
    default: {
      return state
    }
  }
}

export default errorParticipantModalReducer
